import { useCallback } from 'react';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { FilterOptionsState } from '@mui/material/useAutocomplete';
import { CreatableOption, SelectProps, OptionTypeWithCode } from '../../types';

const filterOptions = createFilterOptions<OptionTypeWithCode>({
  ignoreAccents: true,
  ignoreCase: true,
  trim: true,
  matchFrom: 'any',
  stringify: (option) =>
    option.label +
    option.label.replace(/ /g, '') +
    (option.code ?? '').replace(/ /g, '') +
    (option.subLabel ?? []).join('').replace(/ /g, '') +
    (option.chip?.title ?? '').replace(/ /g, '')
});

const noFilter = (options: OptionTypeWithCode[]): OptionTypeWithCode[] => options;

export function useFilterHandler<VALUE>(
  onSearch: SelectProps['onSearch'] | undefined,
  createOptionPrefix: string,
  isCreatable: boolean,
  loading: boolean | undefined
) {
  return useCallback(
    (
      options: (OptionTypeWithCode<VALUE> | CreatableOption)[],
      params: FilterOptionsState<OptionTypeWithCode<VALUE> | CreatableOption>
    ) => {
      const filtered: (OptionTypeWithCode<VALUE> | CreatableOption)[] = !onSearch
        ? filterOptions(options, params)
        : noFilter(options);

      if (params.inputValue !== '' && isCreatable && !loading) {
        filtered.push({
          creatableValue: params.inputValue,
          creatableTitle: `${createOptionPrefix} "${params.inputValue}"`,
          value: params.inputValue,
          label: params.inputValue
        });
      }
      return filtered;
    },
    [createOptionPrefix, isCreatable, loading, onSearch]
  );
}
